import { AdvancedTagMapping } from 'src/features/gateway-details/types';

export function removeDynamicFields(originalValues: AdvancedTagMapping, fieldsToRemove: string[]) {
  const updatedValues = Object.keys(originalValues).reduce((acc: AdvancedTagMapping, field) => {
    if (!fieldsToRemove.includes(field)) {
      acc[field] = originalValues[field];
    }
    return acc;
  }, {} as AdvancedTagMapping);

  return updatedValues;
}
